import React from 'react';
import { theme } from '../../styles/theme';

interface CardProps {
  children: React.ReactNode;
  padding?: 'sm' | 'md' | 'lg' | 'xl';
  elevated?: boolean;
  hoverable?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  children,
  padding = 'lg',
  elevated = true,
  hoverable = false,
  className = '',
  style,
  onClick
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const paddingMap = {
    sm: theme.spacing.sm,
    md: theme.spacing.md,
    lg: theme.spacing.lg,
    xl: theme.spacing.xl
  };

  const cardStyles: React.CSSProperties = {
    backgroundColor: theme.colors.surface,
    borderRadius: theme.borderRadius.lg,
    padding: paddingMap[padding],
    boxShadow: elevated ? theme.shadows.md : 'none',
    border: elevated ? 'none' : `1px solid ${theme.colors.border}`,
    transition: `all ${theme.transitions.base}`,
    cursor: onClick ? 'pointer' : 'default',
    ...(hoverable && isHovered ? {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows.xl
    } : {}),
    ...style
  };

  return (
    <div
      className={`card ${className}`}
      style={cardStyles}
      onClick={onClick}
      onMouseEnter={() => hoverable && setIsHovered(true)}
      onMouseLeave={() => hoverable && setIsHovered(false)}
    >
      {children}
    </div>
  );
};

export default Card;